import React from "react";

import "./Buttons.scss";

const Buttons = (props) => {
  const {
    buttons,
    handleButtonClick,
    buttonContainerClass,
    buttonContainerStyles,
  } = props;

  return (
    <div
      className={`dynamic-buttons d-flex  ${buttonContainerClass}`}
      style={buttonContainerStyles}
    >
      {buttons &&
        buttons.map((button) => (
          <button
            className={`d-flex flex-row justify-content-center ${button.class}`}
            id={button?.id}
            onClick={(e) => handleButtonClick(button.target, button.content)}
            style={button?.style}
          >
            {button?.icon?.position === "start" && (
              <img src={button?.icon.image} width={button?.icon?.size} alt="" />
            )}
            {button?.text && button?.text}
            {button?.icon?.position === "end" && (
              <img src={button?.icon.image} width={button?.icon?.size} alt="" />
            )}
          </button>
        ))}
    </div>
  );
};

export default Buttons;
